// removed by extract-text-webpack-plugin
module.exports = {"rightBorder":"ExchangeRates__rightBorder___2dS-n","exchangeRateSectionPadding":"ExchangeRates__exchangeRateSectionPadding___2XSyg","topInfo":"ExchangeRates__topInfo___3Vh-K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SummarySubSections/ExchangeRateSection/ExchangeRates.less
// module id = 1230
// module chunks = 0